//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CardTransaction from './CardTransaction.vue'
import CardUpgradePlan from './CardUpgradePlan.vue'
import CardMeetingSchedule from './CardMeetingSchedule.vue'
import CardTeamMembers from './CardTeamMembers.vue'
import CardDepositAndWithdraw from './CardDepositAndWithdraw.vue'
import CardTotalEarning from './CardTotalEarning.vue'
import CardFinanceSummary from './CardFinanceSummary.vue'
import CardSocialAnalytics from './CardSocialAnalytics.vue'
import CardWebsiteStatistics from './CardWebsiteStatistics.vue'
import CardDeveloperMeetup from './CardDeveloperMeetup.vue'
import CardSalesByCountries from './CardSalesByCountries.vue'
import CardActivityTimeline from './CardActivityTimeline.vue'
import CardCafeBadilico from './CardCafeBadilico.vue'

export default {
  components: {
    CardTransaction,
    CardUpgradePlan,
    CardMeetingSchedule,
    CardTeamMembers,
    CardDepositAndWithdraw,
    CardTotalEarning,
    CardFinanceSummary,
    CardSocialAnalytics,
    CardWebsiteStatistics,
    CardDeveloperMeetup,
    CardSalesByCountries,
    CardActivityTimeline,
    CardCafeBadilico,
  },
}
